import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=4d316a7d&scoped=true&"
import script from "./EditSupplier.vue?vue&type=script&lang=js&"
export * from "./EditSupplier.vue?vue&type=script&lang=js&"
import style0 from "./EditSupplier.vue?vue&type=style&index=0&id=4d316a7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d316a7d",
  null
  
)

export default component.exports